import React from 'react';

import { RichText, asText } from 'components/rich-text/RichText';
import { TwoColumn, Content } from 'components/two-column/TwoColumn';
import { PrismicRichText } from '../../types/prismicRichtext';

interface ITwoColumnContainer {
  lead: PrismicRichText;
  column_a: PrismicRichText;
  column_b: PrismicRichText;
  isColumnLayout: boolean;
}

export const TwoColumnContainer = ({
  lead,
  column_a,
  column_b,
  isColumnLayout,
}: ITwoColumnContainer) => {

  return (
    <TwoColumn lead={asText(lead)} isColumnLayout={isColumnLayout}>
      {column_a && (
        <Content>
          <RichText>{column_a}</RichText>
        </Content>
      )}
      {column_b && (
        <Content>
          <RichText>{column_b}</RichText>
        </Content>
      )}
    </TwoColumn>
  );
};
